import { PURCHASE_STATE } from './constants'

const defaultState = {
  name: '',
  last: '',
  email: '',
  phone: '',
  address: '',
  city: '',
  holders: [],
  errors: [],
  insuranceIds: [],
  subscribeNewsletter: false,
  isMandatory: null,
}

const state = {
  [PURCHASE_STATE]: {
    ...defaultState,
    errors: [],
    subscribeNewsletter: false,
  },
}

export default state
